import CKEditor from '@ckeditor/ckeditor5-react';
import { PwcCKEditors } from '@pwc/pwc-deals-rich-text-editor';
import classNames from 'classnames';
import React from 'react';
import editorConfig from './CKEditorConfig';
import './RichTextEditor.scss';

const { ClassicEditor } = PwcCKEditors;

/**
 * @deprecated since we are changing editor's type from Classic to Inline
 * The replacement is partial now, this component is for areas which can't be updated to new type for now
 * Should be replaced with RichTextEditorInline.js
 */

const RichTextEditor = ({
  richTextData = '',
  onChange,
  onBlur,
  onFocus,
  isFocused,
  label,
  labelRef,
  config = editorConfig,
  onInit,
  showEmptyRowForTrashIcon = false,
}) => {
  const handleChange = (_, editor) => {
    onChange(editor.getData());
  };

  return (
    <div
      className={classNames(
        'text-input-fieldset fieldset d3-rich-text d3-rich-text--outline',
        {
          focused: isFocused,
        }
      )}
    >
      <div
        data-testid="ckEditor"
        className="text-input-container basic allow-overflow"
      >
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        {label && (
          <label
            className="text-input-control-label"
            htmlFor="ck-editor-component"
            ref={labelRef}
          >
            {label}
          </label>
        )}

        <CKEditor
          id="ck-editor-component"
          editor={ClassicEditor}
          config={config}
          data={richTextData}
          maxCharacters={650}
          onInit={(ckeditor) => {
            if (onInit) onInit(ckeditor);
          }}
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
        />

        {showEmptyRowForTrashIcon && (
          <div className="empty-area-for-trash-icon" />
        )}
      </div>
    </div>
  );
};

export default RichTextEditor;
